module.exports = __webpack_public_path__ + "static/media/IT.327977ba.png";